// app/providers/ClientSentryWrapper.tsx
'use client'

import '../instrumentation-client' // глобально инициализируем Sentry на клиенте

import { useEffect, type ReactNode } from 'react'
import * as Sentry from '@sentry/nextjs'
import { ErrorBoundary } from '@sentry/react'

interface ClientSentryWrapperProps {
  children: ReactNode
  user?: {
    id?: string
    email?: string
  }
}

export function ClientSentryWrapper({ children, user }: ClientSentryWrapperProps) {
  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user.id ?? undefined,
        email: user.email ?? undefined,
      })
    }
  }, [user])

  return <ErrorBoundary fallback={undefined}>{children}</ErrorBoundary>
}
